import React, { useEffect, useRef, useState } from 'react';
import { FormControl } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { hide, saveBuild } from './weaveSaveSlice';

function InnerWeaveSaveModal() {
  const dispatch = useAppDispatch();
  const prevName = useAppSelector(state => state.weaveSave.name);

  const inputRef = useRef<HTMLInputElement>(null);
  const [name, setName] = useState(prevName);

  useEffect(() => {
    inputRef.current?.select();
  }, []);

  const handleSaveClick = () => {
    const newName = name.trim();
    if (newName) {
      dispatch(saveBuild(newName));
    }
  };

  const handleCloseClick = () => {
    dispatch(hide());
  }

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code === 'Enter') {
      e.preventDefault();
      handleSaveClick();
    }
  };

  return (
    <Modal show={true} onHide={() => handleCloseClick()}>
      <Modal.Header closeButton>
        <Modal.Title>Save</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label>Save Name:</label>
        <FormControl as="input" value={name} onChange={handleNameChange} onKeyDown={handleKeyDown} ref={inputRef} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleCloseClick()}>
          Cancel
        </Button>
        <Button variant="primary" onClick={() => handleSaveClick()}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function WeaveSaveModal() {
  const visible = useAppSelector(state => state.weaveSave.visible);  
  return visible ? <InnerWeaveSaveModal/> : null;
}

export default WeaveSaveModal;